import { render, staticRenderFns } from "./NiceBlock.vue?vue&type=template&id=c7338a80&scoped=true&"
import script from "./NiceBlock.vue?vue&type=script&lang=ts&"
export * from "./NiceBlock.vue?vue&type=script&lang=ts&"
import style0 from "./NiceBlock.vue?vue&type=style&index=0&id=c7338a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7338a80",
  null
  
)

export default component.exports